<template>
<div
 	v-show="loading"
	:class="{ 'v-spinner-container': !isInline}"
>
	<div
		class="v-spinner"
		:class="{ 'v-spinner--inline': isInline}"
	>
		<div class="v-rotate v-rotate1" :style="spinnerStyle">
			<div class="v-rotate v-rotate2" :style="spinnerStyle"></div>
			<div class="v-rotate v-rotate3" :style="spinnerStyle"></div>
		</div>
	</div>
</div>
</template>

<script>
export default {
	props: {
		isInline: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: true
		},
		colour: {
			type: String,
			default: '#FFF'
		},
		size: {
			type: String,
			default: '15px'
		},
		margin: {
			type: String,
			default: '2px'
		}
	},
	data() {
		return {
			spinnerStyle: {
				backgroundColor: this.colour,
				height: this.size,
				width: this.size,
				margin: this.margin
			}
		};
	}
};
</script>

<style lang="scss" scoped>
.v-spinner-container {
	background-color: rgba(142, 142, 142, 0.9);
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 250;
}

.v-spinner {
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);

	&--inline {
		position: absolute;
	}

	div {
		border-radius: 100%;
	}

	.v-rotate1 {
		animation: v-rotateStretchDelay 1s 0s infinite cubic-bezier(0.7, -0.13, 0.22, 0.86);
		animation-fill-mode: both;
		display: inline-block;
		position: relative;
	}

	.v-rotate2 {
		opacity: 0.8;
		position: absolute;
		top: 0;
		left: -28px;
	}

	.v-rotate3 {
		opacity: 0.8;
		position: absolute;
		top: 0;
		left: 25px;
	}
}

@-webkit-keyframes v-rotateStretchDelay {
	0% {
		transform: rotate(0deg);
	}

	50% {
		transform: rotate(180deg);
	}

	100% {
		transform: rotate(360deg);
	}
}

@keyframes v-rotateStretchDelay {
	0% {
		transform: rotate(0deg);
	}

	50% {
		transform: rotate(180deg);
	}

	100% {
		transform: rotate(360deg);
	}
}
</style>
